import { render, staticRenderFns } from "./iFrame.vue?vue&type=template&id=c776c2d8&"
import script from "./iFrame.vue?vue&type=script&lang=js&"
export * from "./iFrame.vue?vue&type=script&lang=js&"
import style0 from "./iFrame.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports